import axios from 'axios'
import qs from 'qs'
import store from '@/store'

const client = axios.create({
  baseURL: '',
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  },
  paramsSerializer: params => {
    return qs.stringify(params, { arrayFormat: 'brackets' })
  }
})

let refreshTokenRequest = null

client.interceptors.request.use(
  config => {
    if (store && store.getters.authenticated) {
      config.headers = Object.assign(config.headers, {
        Authorization: 'Bearer ' + store.getters.accessToken
      })
    }

    return {
      ...config,
      onUploadProgress: config.onUploadProgress,
      onDownloadProgress: config.onDownloadProgress
    }
  },
  error => Promise.reject(error)
)

client.interceptors.response.use(
  response => response,
  error => {
    const originalRequest = error.config

    if (
      !originalRequest ||
      originalRequest.skipAuthRefresh ||
      originalRequest._retry ||
      !error.response ||
      error.response.status !== 401 ||
      !store.getters.authenticated
    ) {
      return Promise.reject(error)
    }

    originalRequest._retry = true

    if (!refreshTokenRequest) {
      refreshTokenRequest = store
        .dispatch('refreshToken')
        .catch(refreshError => {
          store.dispatch('logout')

          if (window.location.pathname !== '/login') {
            window.location.href = '/login'
          }

          return Promise.reject(refreshError)
        })
        .finally(() => {
          refreshTokenRequest = null
        })
    }

    return refreshTokenRequest.then(accessToken => {
      originalRequest.headers = Object.assign(originalRequest.headers || {}, {
        Authorization: 'Bearer ' + accessToken
      })

      if (typeof originalRequest.baseURL !== 'string') {
        delete originalRequest.baseURL
      }

      return client(originalRequest)
    })
  }
)

export default client
